import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { Field, reduxForm } from "redux-form";
import { Row, Col, Form, FormGroup, Label, Input } from "reactstrap";
import _ from "lodash";
import { Dropdown, Loading, Valert, Vmodal } from "../components";
import contributeActions from "../actions/contributeActions";
import "./styles/recipeManagement.css";
import "./styles/contributeModern.css";
import { loginRequired } from "../services/UserService";
import { uuidv4 } from "../services/PublicService";
import i18n from "../i18n";
import { compressImageSmart, sanitizeEncodeImage } from "../lib/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import { faPaperclip } from "@fortawesome/pro-light-svg-icons";

const NameImage = (cat) => {
  switch (cat) {
    case "02":
      return require("../images/cont/Food Product Name 2.png");
      break;
    case "04":
      return require("../images/cont/PCP Product Name.png");
      break;
    case "05":
      return require("../images/cont/Medicine Product Name.png");
      break;
    case "06":
      return require("../images/cont/Supplement Product Name.png");
      break;
    default:
      return require("../images/cont/Food Product Name 2.png");
      break;
  }
};
const IngredientImage = (cat) => {
  switch (cat) {
    case "02":
      return require("../images/cont/Food Ingredient.png");
      break;
    case "04":
      return require("../images/cont/PCP Ingredient.png");
      break;
    case "05":
      return require("../images/cont/Medicine Drug Facts.png");
      break;
    case "06":
      return require("../images/cont/Supplement Facts.png");
      break;
    default:
      return require("../images/cont/Food Ingredient.png");
      break;
  }
};
const NutritionImage = (cat) => {
  switch (cat) {
    case "02":
      return require("../images/cont/Food Nutrition Facts.png");
      break;
    case "04":
      return require("../images/cont/PCP Inactive Ingredient or Allergen.png");
      break;
    case "05":
      return require("../images/cont/Medicine ID and Manufacturing Information.png");
      break;
    case "06":
      return require("../images/cont/Supplement Ingredient.png");
      break;
    default:
      return require("../images/cont/Food Nutrition Facts.png");
      break;
  }
};

const IngredientLabel = (cat) => {
  switch (cat) {
    case "02":
      return i18n.t("contribute.CONTRIBUTE_INGREDIENT_PART");
      break;
    case "04":
      return i18n.t("contribute.CONTRIBUTE_INGREDIENT_PART");
      break;
    case "05":
      return i18n.t("contribute.CONTRIBUTE_INGREDIENT_MEDICINE");
      break;
    case "06":
      return i18n.t("contribute.CONTRIBUTE_INGREDIENT_SUPPLEMENT");
      break;
    default:
      return i18n.t("contribute.CONTRIBUTE_INGREDIENT_PART");
      break;
  }
};
const NutritionLabel = (cat) => {
  switch (cat) {
    case "02":
      return i18n.t("contribute.CONTRIBUTE_NUTRITION_PART");
      break;
    case "04":
      return i18n.t("contribute.CONTRIBUTE_NUTRITION_PCP");
      break;
    case "05":
      return i18n.t("contribute.CONTRIBUTE_NUTRITION_MEDICINE");
      break;
    case "06":
      return i18n.t("contribute.CONTRIBUTE_INGREDIENT_PART");
      break;
    default:
      return i18n.t("contribute.CONTRIBUTE_NUTRITION_PART");
      break;
  }
};
class ContributeForm extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      selectedFile: {},
      selectedFile2: {},
    };
  }
  onSelectCategory(newCat) {
    let oldCat = this.props.category;
    if (this.props.formHasData && oldCat === "777" && newCat !== "777") {
      this.IncompleteContribution.changeStatus();
      this.selectedCat = newCat;
    } else if (
      this.props.formHasData &&
      oldCat &&
      oldCat !== "777" &&
      newCat &&
      newCat === "777"
    ) {
      this.IncompleteContribution.changeStatus();
      this.selectedCat = newCat;
    } else {
      this.props.categorySelected(newCat);
    }
  }
  render() {
    const { showBackBtn } = this.props;
    let categories = [
      { value: "02", label: this.props.t("contribute.CATEGORY_FOOD_PRODUCT") },
      { value: "06", label: this.props.t("general.CATEGORY_SUPPLEMENT") },
      { value: "05", label: this.props.t("general.CATEGORY_MEDICINE") },
      { value: "04", label: this.props.t("general.CATEGORY_PCP") },
      { value: "777", label: this.props.t("contribute.CATEGORY_RESTAURANT") },
    ];
    showBackBtn ? categories.pop() : categories;

    return (
      <div>
        <Valert
          display={false}
          title={this.props.t("contribute.INCOMPLETE_CONTRIBUTION_TITLE")}
          question={this.props.t("contribute.INCOMPLETE_CONTRIBUTION_TEXT")}
          onRef={(ref) => (this.IncompleteContribution = ref)}
          positiveAction={() => {
            this.props.onClear();
            this.props.categorySelected(this.selectedCat);

            // Reset per-field "seen once" flags and any pending OCR part.
            this.props.resetOcrPromptFlags && this.props.resetOcrPromptFlags();
          }}
          positiveText={this.props.t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={this.props.t("general.CANCEL")}
        />
        <Form onSubmit={this.props.handleSubmit}>
          <FormGroup>
            <Field
              name="category"
              component={Dropdown}
              options={categories}
              placeholder={
                this.props.category
                  ? ""
                  : this.props.t("symptoms.CATEGORY_TEXT")
              }
              onChange={(e) => {
                this.onSelectCategory(e.target.value);
              }}
              val={this.props.defaultCat}
            />
          </FormGroup>
        </Form>
      </div>
    );
  }
}

ContributeForm = reduxForm({
  form: "formContribute",
  onChange: (values, dispatch, props, previousValues) => {
    props.submit();
  },
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(ContributeForm);

ContributeForm = connect((state) => ({
  initialValues: state.contribute.ContributeForm,
}))(ContributeForm);

class Contribute extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      category: "",
      name: "",
      ingredient: "",
      nutrition: "",
      restImgs: [],
      restName: null,
      imgMagnified: false,
      magnifiedImgUrl: undefined,
      showDeleteImgPrompt: false,
      deleteImgObj: {},
      showBackBtn: false,
      showTextFailed: {                     // once-per-session, per-field
        name: false,
        ingredient: false,
        nutrition: false,
        restName: false,
        menu: false,
      },
      seenOnce: {                     // once-per-session, per-field
        name: false,
        ingredient: false,
        nutrition: false,
        restName: false,
        menu: false,
      },
      awaitingPart: null,             // which field we just submitted OCR for
      awaitingMenuImg: null, // {file, url} for the last uploaded menu image
      compressingCount: 0,
    };
  }

  async componentDidMount() {
    // ✅ Clean unContributed on first mount
    localStorage.removeItem("unContributed");
    loginRequired();

    const url = new URL(window.location.href);
    const showBackBtn = url.searchParams.get("showBackBtn");

    // ✅ Extract initialization logic into a function for reuse
    const initPage = async () => {
      await this.props.initialization(showBackBtn);

      const contDefault = localStorage.getItem("contDefault");
      if (contDefault) {
        const defaultVal = JSON.parse(contDefault);
        this.setState({ category: defaultVal.category });
        this.props.contCategorySelected(defaultVal.category, showBackBtn);
      } else {
        this.setState({ category: "02" });
        this.props.contCategorySelected("02", showBackBtn);
      }
    };

    // Run it once on mount
    await initPage();

    // ✅ Safari BFCache / back-forward cache fix
    this.handlePageShow = async (event) => {
      const navEntries = performance.getEntriesByType("navigation");
      const navType = navEntries.length > 0 ? navEntries[0].type : "";

      if (event.persisted || navType === "back_forward") {
        await initPage(); // Force re-read from latest localStorage / sessionStorage
      }
    };


    window.addEventListener("pageshow", this.handlePageShow);
  }

  componentWillUnmount() {
    if (this.handlePageShow) {
      window.removeEventListener("pageshow", this.handlePageShow);
    }
  }

  componentDidUpdate(prevProps) {
    // Only act when backend signals an OCR error for the last submitted field
    if (!prevProps.failedGetTextFromImg && this.props.failedGetTextFromImg) {
      const part = this.state.awaitingPart;
      if (!part) return; // nothing pending; ignore

      // MENU: show only once per session
      if (part === "menu") {
        if (this.state.seenOnce.menu) {
          // silent accept on subsequent errors
          this.setState({
            showTextFailed: { ...this.state.showTextFailed, menu: false },
            awaitingPart: null,
            awaitingMenuImg: null,
          });
          return;
        }
        // first time → show prompt and mark seen
        this.setState({
          showTextFailed: { ...this.state.showTextFailed, menu: true },
          seenOnce: { ...this.state.seenOnce, menu: true },
          awaitingPart: null,
        });
        return;
      }

      // If we've already shown the prompt for this field in this session → accept silently
      if (this.state.seenOnce[part]) {
        this.setState((prev) => ({
          showTextFailed: { ...prev.showTextFailed, [part]: false },
          awaitingPart: null,
        }));
        return;
      }

      // First time for this field → show prompt and mark as seen
      this.setState((prev) => ({
        showTextFailed: { ...prev.showTextFailed, [part]: true },
        seenOnce: { ...prev.seenOnce, [part]: true },
        awaitingPart: null,
      }));
    }
  }

  leave = (location) => {
    if (this.props.barcode)
      return this.props.t("general.UNSAVED_LEAVE_PAGE_TEXT");
  };

  handleSubmit(values) {}

  categorySelected(e) {
    this.setState({ category: e });
    this.props.contCategorySelected(e);
  }

  async submitImage(file, part) {
    if (file) {

      this.startCompress();
      let fileToSend = file;
      try {
        // fileToSend = file.size > 1000000 ? await compressImageSmart(file) : file;

        // 1) Only compress when > 1MB (your existing helper)
        if (fileToSend.size > 1000000) {
          fileToSend = await compressImageSmart(fileToSend);
        }

        // 2) Always sanitize-encode (avoid WAF/ALB false positives)
        fileToSend = await sanitizeEncodeImage(fileToSend, {
          mimeType: "image/jpeg",
          quality: 0.88,  // or 0.90 if you prefer, but 0.88 is safer
          maxDim: 2048,
        });

        console.log("[upload] final", fileToSend.type, fileToSend.size, fileToSend.name);

      } finally {
        this.endCompress();
      }

      this.props.grabText(fileToSend, part, this.props.barcode);

      this.setState((prev) => ({
        [part]: URL.createObjectURL(fileToSend),
        awaitingPart: part,   // remember which field this OCR is for
      }));
    }
  }

  async submitRestImage(name, file) {
    let images = this.state.restImgs;

    this.startCompress();
    let fileToSend = file;
    try {
      // fileToSend = file && file.size > 1000000 ? await compressImageSmart(file) : file;

      // 1) Only compress when > 1MB (your existing helper)
      if (fileToSend.size > 1000000) {
        fileToSend = await compressImageSmart(fileToSend);
      }

      // 2) Always sanitize-encode (avoid WAF/ALB false positives)
      fileToSend = await sanitizeEncodeImage(fileToSend, {
        mimeType: "image/jpeg",
        quality: 0.88,  // or 0.90 if you prefer, but 0.88 is safer
        maxDim: 2048,
      });

      console.log("[upload] final", fileToSend.type, fileToSend.size, fileToSend.name);

    } finally {
      this.endCompress();
    }

    let image = fileToSend ? { file: fileToSend, url: URL.createObjectURL(fileToSend) } : null;

    if (fileToSend) {
      if (name === "name") {
        this.setState({ restName: image, awaitingPart: "restName" });
      } else {
        images.push(image);
        this.setState({ restImgs: images, awaitingPart: "menu", awaitingMenuImg: image });
      }
      this.props.restAddImg(name, fileToSend);
    }
  }

  closeTextFailedPrompt = (part) => {
    // Handle clicking Ok for Incompatible Image prompt of menu items
    if (part === "menu") {
      const img = this.state.awaitingMenuImg; // {file, url}
      if (img) {
        // remove from UI list
        const restImgs = (this.state.restImgs || []).filter(it => it !== img);
        this.setState({
          restImgs,
          showTextFailed: { ...this.state.showTextFailed, menu: false },
          awaitingMenuImg: null,
        });
        // sync with reducer
        this.props.restDelImg("menu", img.file);
      } else {
        // fallback: just hide prompt if somehow no image remembered
        this.setState({
          showTextFailed: { ...this.state.showTextFailed, menu: false },
        });
      }
      return;
    }

    // Handle clicking Ok for Incompatible Image prompt of non-menu items (name, ingredient, nutrition, restName)
    this.setState((prev) => ({
      [part]: "",  // remove the uploaded image on first prompt OK for the specific
      showTextFailed: { ...prev.showTextFailed, [part]: false },
    }));
  };

  restSubmit() {
    this.props.restSubmit(this.props.restaurant);
  }
  deleteRestImage(name, img, show) {
    if (show) {
      this.setState({ showDeleteImgPrompt: true, deleteImgObj: { name, img } });
    } else {
      if (name === "name") {
        this.setState({
          restName: null,
          deleteImgObj: {},
          showDeleteImgPrompt: false,
        });
        this.props.restDelImg("name", false);
      } else if (name === "menu") {
        let images = this.state.restImgs;
        images = images.filter((item) => item !== img);
        this.setState({
          restImgs: images,
          deleteImgObj: {},
          showDeleteImgPrompt: false,
        });
        this.props.restDelImg("menu", img.file);
      }
    }
  }
  onSubmit() {
    this.props.sendData(
      this.props.contData,
      this.props.barcode,
      this.state.category
    );
    this.posclicked();
  }
  posclicked() {
    this.setState({
      name: "",
      nutrition: "",
      ingredient: "",
    });
    this.props.clear();
  }
  onClear() {
    this.setState({
      name: "",
      nutrition: "",
      ingredient: "",
      category: "",
      barcodeKey: uuidv4(),
      ingredientKey: uuidv4(),
      nutritionKey: uuidv4(),
      nameKey: uuidv4(),
      restImgs: [],
      restName: null,
    });
    this.props.clear();
  }

  handleImageClick = (url, enabled) => {
    if (enabled && url) {
      this.imgMagnify(url);
    }
  };

  imgMagnify(url) {
    this.setState({
      imgMagnified: !this.state.imgMagnified,
      magnifiedImgUrl: url,
    });
  }
  goBackFunc() {
    try {
      sessionStorage.removeItem("previousPageIsDirty");
      localStorage.removeItem("previousPageIsDirty");
    } catch (e) {}

    localStorage.setItem("unContributed", "true");
    localStorage.removeItem("unsavedAlertData");
    this.props.history.goBack();
  }

  goBack() {
    const hasAnyImage =
      !!this.state.restName ||
      (this.state.restImgs && this.state.restImgs.length > 0) ||
      !!this.state.name ||
      !!this.state.nutrition ||
      !!this.state.ingredient;

    console.log("!!this.props.barcode", !!this.props.barcode)
    console.log("hasAnyImage", hasAnyImage)
    if (hasAnyImage) this.props.checkIsDraftDirty();
    else this.goBackFunc();
  }
  closeDeletePrompt() {
    setTimeout(() => {
      this.setState({ showDeleteImgPrompt: false, deleteImgObj: {} });
    }, 100);
  }

  openImageUploader;

  resetOcrPromptFlags = () => {
    this.setState({
      showTextFailed: {
        name: false,
        ingredient: false,
        nutrition: false,
        restName: false,
        menu: false,
      },
      // once-per-session markers per field
      seenOnce: {
        name: false,
        ingredient: false,
        nutrition: false,
        restName: false,
        menu: false,
      },
      // clear pending OCR field (if any)
      awaitingPart: null,
      awaitingMenuImg: null,
    });
  };

  startCompress = () =>
    this.setState(s => ({
      compressingCount: s.compressingCount + 1
    }));

  endCompress = () =>
    this.setState(s => {
      const next = Math.max(0, s.compressingCount - 1);
      return { compressingCount: next };
    });

  render() {
    const { isLoading, t, restaurant, goBackAlert } = this.props;
    const { showDeleteImgPrompt, deleteImgObj } = this.state;
    const url = new URL(window.location.href);
    const showBackBtn = url.searchParams.get("showBackBtn");

    const enabled = {
      // Non-restaurant tiles (image fields enabled when barcode exists)
      name: !!this.props.barcode,
      ingredient: !!this.props.barcode,
      nutrition: !!this.props.barcode,

      // Restaurant menu tile enabled only after restaurant name photo exists
      restMenu: !!this.state.restName,
      menu: !!this.state.restName,

      // Barcode tile enabled when category is chosen and not showBackBtn
      barcode: !showBackBtn && !!this.state.category && this.state.category !== "null",
    };


    const hasAnyImageOrData =
      !!this.state.restName ||
      (this.state.restImgs && this.state.restImgs.length > 0) ||
      !!this.state.name ||
      !!this.state.ingredient ||
      !!this.state.nutrition ||
      !!this.props.barcode; // keep if barcode should also count

    return (
      <div>
        <div className="vPage flex contribute-modern">
          {/*Show loading icon whenever Redux is loading OR we’re compressing:*/}
          <Loading isLoading={isLoading || this.state.compressingCount > 0}/>

          <Valert
            display={this.props.barcodeFailed}
            title={t("BARCODE.BARCODE_ERROR_TITLE")}
            question={t("BARCODE.CONT_BARCODE_ERROR_TEXT")}
            positiveText={t("general.OK_PROMPT_TEXT")}
            readOnly={true}
          />

          <Valert
            display={showDeleteImgPrompt}
            title={t("general.DELETE_CONFIRMATION_TITLE")}
            question={t("general.DELETE_CONFIRMATION_IMAGE_TEXT")}
            positiveAction={() =>
              this.deleteRestImage(deleteImgObj.name, deleteImgObj.img, false)
            }
            positiveText={t("general.POSITIVE_PROMPT_TEXT")}
            negativeText={t("general.CANCEL")}
            negativeAction={() => this.closeDeletePrompt()}
          />
          <Valert
            display={false}
            title={t("general.DELETE_CONFIRMATION_TITLE")}
            question={t("general.DELETE_CONFIRMATION_TEXT")}
            onRef={(ref) => (this.deleteValert = ref)}
            positiveAction={() => {}}
            positiveText={t("general.POSITIVE_PROMPT_TEXT")}
            negativeText={t("general.CANCEL")}
          />
          <Valert
            display={this.props.notAllowed}
            title={t("contribute.NOT_ALLOWED_CONTRIBUTE_TITLE")}
            question={t("contribute.NOT_ALLOWED_CONTRIBUTE_TEXT")}
            onRef={(ref) => (this.notAllowed = ref)}
            positiveText={t("general.OK_PROMPT_TEXT")}
            readOnly={true}
          />
          <Valert
            display={this.props.notAllowedByUser}
            title={t("contribute.ALREADY_CONTRIBUTED_TITLE")}
            question={t("contribute.ALREADY_CONTRIBUTED_TEXT")}
            onRef={(ref) => (this.notAllowedByUser = ref)}
            positiveText={t("general.OK_PROMPT_TEXT")}
            readOnly={true}
          />

          <Valert
            display={
              this.state.showTextFailed.name &&
              this.props.failedGetTextFromImg
            }
            title={t("contribute.INCOMPATIBLE_IMAGE_TITLE")}
            question={t("contribute.INCOMPATIBLE_IMAGE_TEXT")}
            positiveText={t("general.OK_PROMPT_TEXT")}
            positiveAction={() => this.closeTextFailedPrompt("name")}
            readOnly={true}
          />
          <Valert
            display={
              this.state.showTextFailed.ingredient &&
              this.props.failedGetTextFromImg
            }
            title={t("contribute.INCOMPATIBLE_IMAGE_TITLE")}
            question={t("contribute.INCOMPATIBLE_IMAGE_TEXT")}
            positiveText={t("general.OK_PROMPT_TEXT")}
            positiveAction={() => this.closeTextFailedPrompt("ingredient")}
            readOnly={true}
          />
          <Valert
            display={
              this.state.showTextFailed.nutrition &&
              this.props.failedGetTextFromImg
            }
            title={t("contribute.INCOMPATIBLE_IMAGE_TITLE")}
            question={t("contribute.INCOMPATIBLE_IMAGE_TEXT")}
            positiveText={t("general.OK_PROMPT_TEXT")}
            positiveAction={() => this.closeTextFailedPrompt("nutrition")}
            readOnly={true}
          />
          <Valert
            display={
              this.state.showTextFailed.restName &&
              this.props.failedGetTextFromImg
            }
            title={t("contribute.INCOMPATIBLE_IMAGE_TITLE")}
            question={t("contribute.INCOMPATIBLE_IMAGE_TEXT")}
            positiveText={t("general.OK_PROMPT_TEXT")}
            positiveAction={() => {
              this.props.clearDirtyDraft();
              this.closeTextFailedPrompt("restName");
            }}
            readOnly={true}
          />
          <Valert
            display={
              this.state.showTextFailed.menu &&
              this.props.failedGetTextFromImg
            }
            title={t("contribute.INCOMPATIBLE_IMAGE_TITLE")}
            question={t("contribute.INCOMPATIBLE_IMAGE_TEXT")}
            positiveText={t("general.OK_PROMPT_TEXT")}
            positiveAction={() => this.closeTextFailedPrompt("menu")}
            readOnly={true}
          />
          <Valert
            display={this.props.repeatedBarcode}
            title={t("contribute.ALREADY_CONTRIBUTED_BY_ELSE_TITLE")}
            question={t("contribute.ALREADY_CONTRIBUTED_BY_ELSE_TEXT")}
            onRef={(ref) => (this.repeatedBarcode = ref)}
            positiveText={t("general.OK_PROMPT_TEXT")}
            readOnly={true}
          />
          <Valert
            display={false}
            question={t("contribute.CLEAR_CONTRIBUTE_TEXT")}
            title={t("general.CLEAR_CONFIRMATION_TITLE")}
            onRef={(ref) => (this.clearAlert = ref)}
            positiveAction={() => {
              this.onClear();
              this.resetOcrPromptFlags();
            }}
            positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          />
          <Valert
            display={false}
            // title="Already Exist"
            question={t("contribute.SCAN_BARCODE_TEXT")}
            onRef={(ref) => (this.disabledAlert = ref)}
            //positiveAction={this.savedAddItem}
            positiveText={t("general.OK_PROMPT_TEXT")}
            readOnly={true}
          />

          <Valert
            display={goBackAlert}
            title={t("contribute.UNSAVED_CONT_DATA_TITLE")}
            question={t("contribute.UNSAVED_CONT_DATA_TEXT_2")}
            onRef={(ref) => (this.goBackAlert = ref)}
            positiveAction={() => this.goBackFunc()}
            positiveText={t("general.POSITIVE_PROMPT_TEXT")}
            negativeText={t("general.CANCEL")}
            negativeAction={() =>
              setTimeout(() => this.props.clearDirtyDraft(), 10)
            }
          />

          <Vmodal
            zIndex={10}
            displayStatus={this.state.imgMagnified}
            data={
              <div
                style={{
                  width: "-webkit-fill-available",
                }}
                onClick={() => {
                  this.imgMagnify();
                }}
              >
                <img
                  className={"valertContainerImage"}
                  src={this.state.magnifiedImgUrl}
                />
              </div>
            }
            closeFunc={() => {
              this.imgMagnify();
            }}
            image={true}
          />

          <Vmodal
            displayStatus={this.props.thank}
            data={
              <div>
                <h4>{t("contribute.CONTRIBUTE_SUCCESSFUL_TITLE")}</h4>
                <p>{t("contribute.CONTRIBUTE_SUCCESSFUL_TEXT")}</p>
              </div>
            }
            closeFunc={
              this.props.cameFrom
                ? () => {
                  window.location.href = `/${this.props.cameFrom}`;
                }
                : () => {
                  this.props.clearDirtyDraft();
                  window.location.reload();
                }
            }
            timedClose={2000}
          />

          <ContributeForm
            onSubmit={this.handleSubmit.bind(this)}
            t={t}
            category={this.state.category}
            categorySelected={this.categorySelected.bind(this)}
            defaultCat={this.props.contData.category}
            onClear={this.onClear.bind(this)}
            formHasData={hasAnyImageOrData}
            showBackBtn={showBackBtn}
            resetOcrPromptFlags={this.resetOcrPromptFlags}
          />
          {/* ================= For Restaurant Foods category ========================== */}
          {this.state.category === "777" ? (
            <div
              className="cont-box-wrap"
              style={{ columnGap: "10px", rowGap: "5px" }}
            >
              {/* start */}
              <div
                className="cont-box"
                style={{
                  position: "relative",
                  backgroundColor: "rgb(255, 255, 255)",
                }}
              >
                <Label
                  style={{
                    width: "100%",
                    height: "100%",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: 18,
                    color: "#666",
                    cursor: "pointer",
                    position: "relative",
                    whiteSpace: "pre-line",
                  }}
                  for="rest-name"
                >
                  {!this.state.imgMagnified && (
                    <Input
                      style={{ display: "none" }}
                      type="file"
                      name="file"
                      id="rest-name"
                      accept="image/*"
                      multiple={false}
                      onChange={(e) => {
                        e.preventDefault();
                        e.target.files && e.target.files.length > 0
                          ? this.submitRestImage("name", e.target.files[0])
                          : null;
                      }}
                      onClick={(e) => (e.target.value = null)}
                    />
                  )}

                  <div
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 18,
                      color: "#222",
                      zIndex: 1,
                    }}
                  >
                    {t("contribute.RESTAURANT_NAME")}
                  </div>
                  {this.state.restName ? (
                    <div
                      style={{
                        flex: 1,
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: this.state.restName ? "" : "center",
                        display: "flex",
                      }}
                    >
                      <img
                        style={{ maxWidth: "90%", maxHeight: 100 }}
                        src={this.state.restName.url}
                        onClick={() => {
                          this.handleImageClick(this.state.restName.url, this.state.restName.url);
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "90%",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <img
                        style={{
                          maxWidth: 160,
                          maxHeight: 160,
                          alignSelf: "center",
                        }}
                        src={require("../images/cont/Restaurant Menu Name.png")}
                        alt=""
                      />
                    </div>
                  )}
                  <div className="p-1 text-center">
                    {/* <i
                      style={{
                        fontSize: 26,
                        color:
                          this.state.category && this.state.category != "null"
                            ? "#007bff"
                            : "#C3C3C3",
                        fontWeight: "900",
                      }}
                      className="fas fa-paperclip"
                    ></i> */}

                    <FontAwesomeIcon
                      className="fas fa-paperclip"
                      icon={faPaperclip}
                      style={{
                        color:
                          this.state.category && this.state.category != "null"
                            ? "#007bff"
                            : "#C3C3C3",
                        fontSize: 26,
                      }}
                    />

                  </div>
                </Label>
              </div>
              {/* end */}
              <div
                className="cont-box"
                style={{
                  backgroundColor: this.state.restName
                    ? "rgb(255, 255, 255)"
                    : "rgb(241, 243, 245)",
                }}
              >
                <Label
                  for="rest-menu"
                  style={{
                    width: "100%",
                    height: "100%",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: 18,
                    position: "relative",
                    color: this.state.restName ? "#666" : "#c3c3c3",
                    cursor: this.state.restName ? "pointer" : "default",
                  }}
                >
                  <Input
                    disabled={this.state.restName ? false : true}
                    style={{ display: "none" }}
                    type="file"
                    name="file"
                    id="rest-menu"
                    accept="image/*"
                    multiple={false}
                    onChange={(e) => {
                      e.preventDefault();
                      e.target.files && e.target.files.length > 0
                        ? this.submitRestImage("menu", e.target.files[0])
                        : null;
                    }}
                    onClick={(e) => (e.target.value = null)}
                  />
                  <div
                    style={{
                      flex: 1,
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 18,
                      zIndex: 1,
                      color: "#222",
                    }}
                  >
                    {t("contribute.MENU_ITEMS")}
                  </div>

                  <div
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: 180,
                        maxHeight: 180,
                        resizeMode: "contain",
                        alignSelf: "center",
                        paddingBottom: "7%",
                      }}
                      src={require("../images/cont/Restaurant Menu Menu Items.png")}
                      alt=""
                    />
                  </div>
                  <div className="p-1 text-center">
                    {/* <i
                      style={{
                        fontSize: 26,
                        color: this.state.restName ? "#007bff" : "#C3C3C3",
                        fontWeight: "900",
                      }}
                      className="fas fa-paperclip"
                    ></i> */}

                    <FontAwesomeIcon
                      className="fas fa-paperclip"
                      icon={faPaperclip}
                      style={{
                        color: this.state.restName ? "#007bff" : "#C3C3C3",
                        fontSize: 26,
                      }}
                    />

                  </div>
                </Label>
              </div>
              {this.state.restImgs &&
                this.state.restImgs.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="cont-box"
                      style={{
                        backgroundColor: enabled.menu ? "rgb(255, 255, 255)" : "rgb(241, 243, 245)",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: 18,
                          color: "#666",
                          position: "relative",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (this.state.restName.url) {
                              this.deleteRestImage("menu", item, true)
                            }
                          }}
                          style={{
                            position: "absolute",
                            bottom: 25,
                            right: "50%",
                            width: 15,
                            height: 15,
                            cursor: enabled.menu ? "pointer" : "default",
                          }}
                        >
                          <i
                            className="far fa-trash-alt"
                            style={{ fontSize: 15, color: this.state.restName.url ? "#007bff" : "#C3C3C3" }}
                          ></i>
                        </div>
                        <img
                          style={{
                            width: "90%",
                            maxHeight: "90%",
                            objectFit: "contain",
                            paddingBottom: 35,
                            cursor: enabled.menu ? "pointer" : "default",
                          }}
                          className={enabled.restMenu ? "" : "img-disabled"}
                          src={item.url}
                          onClick={() => {
                            this.handleImageClick(item.url, enabled.menu);
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          ) : (
            <div
              className="cont-box-wrap"
              style={{ columnGap: "10px", rowGap: "0px" }}
            >
              {/* ================= Non-Restaurant Foods categories ========================== */}

              <div
                className="cont-box"
                style={{
                  position: "relative",
                  backgroundColor:
                    this.state.category &&
                      this.state.category != "null" &&
                      !showBackBtn
                      ? "rgb(255, 255, 255)"
                      : "rgb(241, 243, 245)",
                }}
              >
                <Label
                  style={{
                    flexDirection: "column",
                    height: "100%",
                    display: "flex",
                    position: "relative",
                    cursor:
                      this.state.category && this.state.category != "null"
                        ? "pointer"
                        : "default",
                  }}
                  for="barcodeFile"
                >
                  <Input
                    disabled={
                      showBackBtn
                        ? true
                        : this.state.category && this.state.category != "null"
                          ? false
                          : true
                    }
                    style={{ display: "none" }}
                    key={this.state.barcodeKey || ""}
                    type="file"
                    name="file"
                    id="barcodeFile"
                    accept="image/*"
                    multiple={false}
                    // onChange={(e) => {
                    //   e.target.files && e.target.files.length > 0
                    //     ? this.props.barcodeSearch(e.target.files[0])
                    //     : null;
                    // }}
                    onChange={async (e) => {
                      const f = e && e.target && e.target.files && e.target.files[0];
                      if (!f) return;

                      this.startCompress();
                      let fileToSend = f;
                      try {
                        // fileToSend = f.size > 1000000 ? await compressImageSmart(f) : f;

                        // 1) Only compress when > 1MB (your existing helper)
                        if (fileToSend.size > 1000000) {
                          fileToSend = await compressImageSmart(fileToSend);
                        }

                        // 2) Always sanitize-encode (avoid WAF/ALB false positives)
                        fileToSend = await sanitizeEncodeImage(fileToSend, {
                          mimeType: "image/jpeg",
                          quality: 0.88,  // or 0.90 if you prefer, but 0.88 is safer
                          maxDim: 2048,
                        });

                        console.log("[upload] final", fileToSend.type, fileToSend.size, fileToSend.name);

                      } finally {
                        this.endCompress();
                      }

                      this.props.barcodeSearch(fileToSend);
                    }}
                    onClick={(e) => (e.target.value = null)}
                  />
                  <div
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 18,
                      zIndex: 1,
                      color: showBackBtn ? "rgb(153,153,153)" : "#222",
                    }}
                  >
                    {t("products.UPC_DEFAULT_TEXT")}
                  </div>
                  {this.props.barcode ? (
                    <div
                      style={{
                        flex: 1,
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        textAlign: "center",
                        fontSize: 18,
                        color: "rgb(153,153,153)",
                      }}
                    >
                      {this.props.barcode}
                    </div>
                  ) : (
                    <div
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "90%",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <img
                        style={{
                          maxWidth: 180,
                          maxHeight: 180,
                          resizeMode: "contain",
                          alignSelf: "center",
                        }}
                        src={require("../images/cont/Barcode.png")}
                        alt=""
                      />
                    </div>
                  )}
                  {/* for Troubleshoot  */}
                  {!showBackBtn && (
                    <div className="p-1 text-center">
                      {/* <i
                        style={{
                          fontSize: 26,
                          color:
                            this.state.category && this.state.category != "null"
                              ? "#007bff"
                              : "#C3C3C3",
                          fontWeight: "900",
                        }}
                        className="fas fa-paperclip"
                      ></i> */}

                      <FontAwesomeIcon
                        className="fas fa-paperclip"
                        icon={faPaperclip}
                        style={{
                          color:
                            this.state.category && this.state.category != "null"
                              ? "#007bff"
                              : "#C3C3C3",
                          fontSize: 26,
                        }}
                      />
                    </div>
                  )}
                </Label>
              </div>
              <div
                className="cont-box"
                style={{
                  position: "relative",
                  backgroundColor: this.props.barcode
                    ? "rgb(255, 255, 255)"
                    : "rgb(241, 243, 245)",
                }}
              >
                <Label
                  style={{
                    flexDirection: "column",
                    height: "100%",
                    display: "flex",
                    cursor: this.props.barcode ? "pointer" : "default",
                  }}
                  for="nameFile"
                >
                  {!this.state.imgMagnified && (
                    <Input
                      disabled={this.props.barcode ? false : true}
                      key={this.state.nameKey || ""}
                      style={{ display: "none" }}
                      type="file"
                      name="file"
                      id="nameFile"
                      accept="image/*"
                      multiple={false}
                      onChange={(e) => {
                        this.submitImage(e.target.files[0], "name");
                      }}
                      onClick={(e) => (e.target.value = null)}
                    />
                  )}

                  <div
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 18,
                      color: "#222",
                      zIndex: 1,
                    }}
                  >
                    {t("products.PRODUCT_DEFAULT_TEXT")}
                  </div>
                  {this.state.name ? (
                    <div
                      style={{
                        flex: 1,
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <img
                        style={{ maxWidth: "90%", height: 100 }}
                        className={this.props.barcode ? "" : "img-disabled"}
                        src={this.state.name}
                        onClick={() => {
                          this.handleImageClick(this.state.name, this.props.barcode);
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "90%",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <img
                        style={{
                          maxWidth: 180,
                          maxHeight: 180,
                          resizeMode: "contain",
                          alignSelf: "center",
                        }}
                        src={NameImage(this.state.category)}
                        alt=""
                      />
                    </div>
                  )}
                  <div className="p-1 text-center">
                    {/* <i
                      style={{
                        fontSize: 26,
                        color:
                          this.state.category &&
                            this.state.category != "null" &&
                            this.props.barcode
                            ? "#007bff"
                            : "#C3C3C3",
                        fontWeight: "900",
                      }}
                      className="fas fa-paperclip"
                    ></i> */}

                    <FontAwesomeIcon
                      className="fas fa-paperclip"
                      icon={faPaperclip}
                      style={{
                        color:
                          this.state.category &&
                            this.state.category != "null" &&
                            this.props.barcode
                            ? "#007bff"
                            : "#C3C3C3",
                        fontSize: 26,
                      }}
                    />

                  </div>
                </Label>
              </div>

              <div
                className="cont-box"
                style={{
                  position: "relative",
                  backgroundColor: this.props.barcode
                    ? "rgb(255, 255, 255)"
                    : "rgb(241, 243, 245)",
                }}
              >
                <Label
                  style={{
                    flexDirection: "column",
                    height: "100%",
                    display: "flex",
                    cursor: this.props.barcode ? "pointer" : "default",
                  }}
                  for="ingredientFile"
                >
                  {!this.state.imgMagnified && (
                    <Input
                      disabled={this.props.barcode ? false : true}
                      key={this.state.ingredientKey || ""}
                      style={{ display: "none" }}
                      type="file"
                      name="file"
                      id="ingredientFile"
                      accept="image/*"
                      multiple={false}
                      onChange={(e) => {
                        this.submitImage(e.target.files[0], "ingredient");
                      }}
                      onClick={(e) => (e.target.value = null)}
                    />
                  )}

                  <div
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 18,
                      color: "#222",
                      zIndex: 1,
                    }}
                  >
                    {IngredientLabel(this.state.category)}
                  </div>
                  {this.state.ingredient ? (
                    <div
                      style={{
                        flex: 1,
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <img
                        style={{ maxWidth: "90%", height: 100 }}
                        className={this.props.barcode ? "" : "img-disabled"}
                        src={this.state.ingredient}
                        onClick={() => {
                          this.handleImageClick(this.state.ingredient, this.props.barcode);
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "90%",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <img
                        style={{
                          maxWidth: 180,
                          maxHeight: 180,
                          resizeMode: "contain",
                          alignSelf: "center",
                        }}
                        src={IngredientImage(this.state.category)}
                        alt=""
                      />
                    </div>
                  )}
                  <div className="p-1 text-center">
                    {/* <i
                      style={{
                        fontSize: 26,
                        color:
                          this.state.category &&
                            this.state.category != "null" &&
                            this.props.barcode
                            ? "#007bff"
                            : "#C3C3C3",
                        fontWeight: "900",
                      }}
                      className="fas fa-paperclip"
                    ></i> */}

                    <FontAwesomeIcon
                      className="fas fa-paperclip"
                      icon={faPaperclip}
                      style={{
                        color:
                          this.state.category &&
                            this.state.category != "null" &&
                            this.props.barcode
                            ? "#007bff"
                            : "#C3C3C3",
                        fontSize: 26,
                      }}
                    />

                  </div>
                </Label>
              </div>
              <div
                className="cont-box"
                style={{
                  position: "relative",
                  backgroundColor: this.props.barcode
                    ? "rgb(255, 255, 255)"
                    : "rgb(241, 243, 245)",
                }}
              >
                <Label
                  style={{
                    flexDirection: "column",
                    height: "100%",
                    display: "flex",
                    cursor: this.props.barcode ? "pointer" : "default",
                  }}
                  for="nutritionFile"
                >
                  {!this.state.imgMagnified && (
                    <Input
                      disabled={this.props.barcode ? false : true}
                      key={this.state.nutritionKey || ""}
                      style={{ display: "none" }}
                      type="file"
                      name="file"
                      id="nutritionFile"
                      accept="image/*"
                      multiple={false}
                      onChange={(e) => {
                        this.submitImage(e.target.files[0], "nutrition");
                      }}
                      onClick={(e) => (e.target.value = null)}
                    />
                  )}

                  <div
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 18,
                      color: "#222",
                      zIndex: 1,
                    }}
                  >
                    {NutritionLabel(this.state.category)}
                  </div>
                  {this.state.nutrition ? (
                    <div
                      style={{
                        flex: 1,
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        textAlign: "center",
                        fontSize: 18,
                        color: "#666",
                      }}
                    >
                      <img
                        style={{ maxWidth: "90%", height: 100 }}
                        className={this.props.barcode ? "" : "img-disabled"}
                        src={this.state.nutrition}
                        onClick={() => {
                          this.handleImageClick(this.state.nutrition, this.props.barcode);
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "90%",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <img
                        style={{
                          maxWidth: 180,
                          maxHeight: 180,
                          resizeMode: "contain",
                          alignSelf: "center",
                        }}
                        src={NutritionImage(this.state.category)}
                        alt=""
                      />
                    </div>
                  )}
                  <div className="p-1 text-center">
                    {/* <i
                      style={{
                        fontSize: 26,
                        color:
                          this.state.category &&
                            this.state.category != "null" &&
                            this.props.barcode
                            ? "#007bff"
                            : "#C3C3C3",
                        fontWeight: "900",
                      }}
                      className="fas fa-paperclip"
                    ></i> */}

                    <FontAwesomeIcon
                      className="fas fa-paperclip"
                      icon={faPaperclip}
                      style={{
                        color:
                          this.state.category &&
                            this.state.category != "null" &&
                            this.props.barcode
                            ? "#007bff"
                            : "#C3C3C3",
                        fontSize: 26,
                      }}
                    />

                  </div>
                </Label>
              </div>
            </div>
          )}

          <Row style={{ height: 50 }}>
            <Col>
              <button
                type="button"
                className="btn btn-primary btnWide"
                disabled={
                  this.state.category === "02" &&
                    this.state.nutrition &&
                    this.state.name &&
                    this.state.ingredient &&
                    this.props.barcode
                    ? false
                    : this.state.category &&
                      this.state.category !== "02" &&
                      this.state.name &&
                      this.state.ingredient &&
                      this.props.barcode
                      ? false
                      : this.state.category === "777" && this.state.restName
                        ? false
                        : true
                }
                onClick={() => {
                  sessionStorage.removeItem("previousPageIsDirty"); // ✅ Clear session flag

                  if (this.state.category === "777") {
                    this.restSubmit();
                  } else {
                    this.onSubmit();
                  }
                }}
              >
                {t("general.SUBMIT")}
              </button>
            </Col>
            <Col>
              {this.state.category && showBackBtn ? (
                <button
                  type="button"
                  className="btn btn-primary btnWide"
                  disabled={false}
                  onClick={() => this.goBack()}
                >
                  {t("general.CANCEL")}
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary btnWide"
                  disabled={
                    this.state.nutrition ||
                      this.state.name ||
                      this.state.ingredient ||
                      this.props.barcode ||
                      this.state.restImgs.length > 0 ||
                      this.state.restName ||
                      (this.state.category && this.state.category != "null")
                      ? false
                      : true
                  }
                  onClick={() => this.clearAlert.changeStatus()}
                >
                  {t("general.CLEAR")}
                </button>
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

Contribute = translate("translations")(Contribute);

const mapStateToProps = (state) => ({
  ...state.contribute,
  formContribute: state.form.formContribute,
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators({ ...contributeActions }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(Contribute);



// WEBPACK FOOTER //
// ./src/pages/Contribute.js